import RecaptchaFormControl from 'account/RecaptchaFormControl';
import ResetPasswordFormControl from 'account/resetPassword/ResetPasswordFormControl';
import 'account/orderHistory';
import 'account/myPreferences';
import 'account/myCompany';

const forgottenPwdForm = document.getElementById('forgottenPwdForm');
if (forgottenPwdForm) {
	new RecaptchaFormControl(forgottenPwdForm);
}

const resetPasswordForm = document.getElementById('resetPasswordForm');
if (resetPasswordForm) {
	new ResetPasswordFormControl(resetPasswordForm);
	new window.od.PasswordStrength(resetPasswordForm);
}
